type IMakeModel = Array<{ Make: string; ModelList: string[] }>

const makesModels: IMakeModel = [
  {
    Make: 'ABARTH',
    ModelList: ['124 SPIDER', '500', '595', '695', 'GRANDE PUNTO', 'PUNTO EVO'],
  },
  {
    Make: 'AC',
    ModelList: ['COBRA'],
  },
  {
    Make: 'ALFA ROMEO',
    ModelList: [
      '145',
      '146',
      '147',
      '155',
      '156',
      '159',
      '164',
      '166',
      '4C',
      '8C',
      'BRERA',
      'GIULIA',
      'GIULIETTA',
      'GT',
      'GTV',
      'MITO',
      'SPIDER',
      'STELVIO',
    ],
  },
  {
    Make: 'ARIEL',
    ModelList: ['ATOM', 'NOMAD'],
  },
  {
    Make: 'ASTON MARTIN',
    ModelList: ['CYGNET', 'DB11', 'DB7', 'DB9', 'DBS', 'RAPIDE', 'VANQUISH', 'VANTAGE', 'VIRAGE'],
  },
  {
    Make: 'AUDI',
    ModelList: [
      '80',
      'A1',
      'A2',
      'A3',
      'A4',
      'A4 ALLROAD',
      'A5',
      'A6',
      'A6 ALLROAD',
      'A7',
      'A8',
      'ALLROAD',
      'CABRIOLET',
      'CONVERTIBLE',
      'COUPE',
      'E-TRON',
      'Q2',
      'Q3',
      'Q5',
      'Q7',
      'Q8',
      'R8',
      'RS Q3',
      'RS3',
      'RS4',
      'RS5',
      'RS6',
      'RS7',
      'S1',
      'S3',
      'S4',
      'S5',
      'S6',
      'S7',
      'S8',
      'SQ2',
      'SQ5',
      'SQ7',
      'TT',
      'TT RS',
      'TTS',
    ],
  },
  {
    Make: 'AUSTIN',
    ModelList: ['HEALEY'],
  },
  {
    Make: 'BENTLEY',
    ModelList: ['ARNAGE', 'AZURE', 'BENTAYGA', 'BROOKLANDS', 'CONTINENTAL', 'FLYING SPUR', 'MULSANNE', 'TURBO R'],
  },
  {
    Make: 'BMW',
    ModelList: [
      '1 SERIES',
      '2 SERIES',
      '3 SERIES',
      '4 SERIES',
      '5 SERIES',
      '6 SERIES',
      '7 SERIES',
      '8 SERIES',
      'ALPINA',
      'I3',
      'I8',
      'M1',
      'M2',
      'M3',
      'M4',
      'M5',
      'M6',
      'X1',
      'X2',
      'X3',
      'X4',
      'X5',
      'X6',
      'X7',
      'Z1',
      'Z3',
      'Z4',
      'Z8',
    ],
  },
  {
    Make: 'BUGATTI',
    ModelList: ['CHIRON', 'VEYRON'],
  },
  {
    Make: 'CATERHAM',
    ModelList: ['SEVEN'],
  },
  {
    Make: 'CHEVROLET',
    ModelList: [
      'AVEO',
      'BLAZER',
      'C6',
      'CAMARO',
      'CAPTIVA',
      'CORVETTE',
      'CRUZE',
      'EPICA',
      'KALOS',
      'LACETTI',
      'MATIZ',
      'ORLANDO',
      'SPARK',
      'STINGRAY',
      'TACUMA',
      'TRAX',
      'VOLT',
    ],
  },
  {
    Make: 'CHRYSLER',
    ModelList: ['300C', 'CROSSFIRE', 'DELTA', 'GRAND VOYAGER', 'NEON', 'PT CRUISER', 'SEBRING', 'VOYAGER', 'YPSILON'],
  },
  {
    Make: 'CITROEN',
    ModelList: [
      'BERLINGO FIRST',
      'BERLINGO MULTISPACE',
      'C ZERO',
      'C1',
      'C2',
      'C3',
      'C3 AIRCROSS',
      'C3 PICASSO',
      'C3 PLURIEL',
      'C4',
      'C4 CACTUS',
      'C4 PICASSO',
      'C5',
      'C5 AIRCROSS',
      'C6',
      'C8',
      'C-CROSSER',
      'DISPATCH COMBI',
      'DS3',
      'DS4',
      'DS5',
      'GRAND C4 PICASSO',
      'GRAND C4 SPACETOURER',
      'NEMO MULTISPACE',
      'SAXO',
      'SYNERGIE',
      'XANTIA',
      'XSARA',
      'XSARA PICASSO',
    ],
  },
  {
    Make: 'DACIA',
    ModelList: ['DUSTER', 'LOGAN', 'LOGAN STEPWAY', 'SANDERO', 'SANDERO STEPWAY'],
  },
  {
    Make: 'DAEWOO',
    ModelList: ['KALOS', 'KORANDO', 'LACETTI', 'LANOS', 'LEGANZA', 'MATIZ', 'MUSSO', 'NUBIRA', 'TACUMA'],
  },
  {
    Make: 'DAIHATSU',
    ModelList: [
      'CHARADE',
      'COPEN',
      'CUORE',
      'FOURTRAK',
      'GRAND MOVE',
      'MATERIA',
      'MOVE',
      'SIRION',
      'SPORTRAK',
      'TERIOS',
      'YRV',
    ],
  },
  {
    Make: 'DODGE',
    ModelList: ['AVENGER', 'CALIBER', 'CHALLENGER', 'JOURNEY', 'NITRO'],
  },
  {
    Make: 'DS',
    ModelList: ['DS 3', 'DS 4', 'DS 5', 'DS 7'],
  },
  {
    Make: 'FERRARI',
    ModelList: [
      '308',
      '328',
      '348',
      '360M',
      '365',
      '430',
      '456',
      '456M',
      '458',
      '488',
      '488 GTB',
      '512',
      '550',
      '575M',
      '599',
      '612',
      '812 SUPERFAST',
      'CALIFORNIA',
      'DINO',
      'ENZO',
      'F12 BERLINETTA',
      'F355',
      'F430',
      'FF',
      'GTC4 LUSSO',
      'LAFERRARI',
      'PORTOFINO',
      'TESTAROSSA',
      'F40',
      'F50',
      '246',
      '250',
    ],
  },
  {
    Make: 'FIAT',
    ModelList: [
      '124 SPIDER',
      '500',
      '500L',
      '500L MPW',
      '500X',
      'BARCHETTA',
      'BRAVA',
      'BRAVO',
      'CINQUECENTO',
      'COUPE',
      'CROMA',
      'DOBLO',
      'FIORINO',
      'GRANDE PUNTO',
      'IDEA',
      'MAREA',
      'MULTIPLA',
      'PANDA',
      'PUNTO',
      'PUNTO EVO',
      'QUBO',
      'SCUDO',
      'SEDICI',
      'SEICENTO',
      'STILO',
      'TIPO',
      'ULYSSE',
      'FULLBACK',
    ],
  },
  {
    Make: 'FORD',
    ModelList: [
      'B-MAX',
      'CAPRI',
      'C-MAX',
      'COUGAR',
      'ECOSPORT',
      'EDGE',
      'ESCORT',
      'EXPLORER',
      'F150',
      'FIESTA',
      'FOCUS',
      'FUSION',
      'GALAXY',
      'GRAND C-MAX',
      'GRAND TOURNEO CONNECT',
      'GT',
      'KA',
      'KA+',
      'KUGA',
      'MAVERICK',
      'MONDEO',
      'MUSTANG',
      'PROBE',
      'PUMA',
      'RANGER',
      'SCORPIO',
      'SIERRA',
      'S-MAX',
      'S-MAX VIGNALE',
      'STREETKA',
      'TOURNEO CONNECT',
      'TRANSIT COURIER',
    ],
  },
  {
    Make: 'GREAT WALL',
    ModelList: ['STEED'],
  },
  {
    Make: 'HONDA',
    ModelList: [
      'ACCORD',
      'AERODECK',
      'CIVIC',
      'CR-V',
      'CR-X',
      'CR-Z',
      'FR-V',
      'HR-V',
      'INSIGHT',
      'INTEGRA',
      'JAZZ',
      'LEGEND',
      'LOGO',
      'NSX',
      'PRELUDE',
      'S2000',
      'SHUTTLE',
      'STEPWAGON',
      'STREAM',
    ],
  },
  {
    Make: 'HUMMER',
    ModelList: ['H2', 'H3'],
  },
  {
    Make: 'HYUNDAI',
    ModelList: [
      'ACCENT',
      'AMICA',
      'ATOZ',
      'COUPE',
      'ELANTRA',
      'GENESIS',
      'GETZ',
      'GRANDEUR',
      'I10',
      'I20',
      'I30',
      'I40',
      'I800',
      'IONIQ',
      'IX20',
      'IX35',
      'KONA',
      'LANTRA',
      'MATRIX',
      'SANTA FE',
      'SONATA',
      'TERRACAN',
      'TRAJET',
      'TUCSON',
      'VELOSTER',
      'XG30',
    ],
  },
  {
    Make: 'INFINITI',
    ModelList: ['EX', 'FX', 'G37', 'M', 'Q30', 'Q50', 'Q60', 'Q70', 'QX30', 'QX50', 'QX70'],
  },
  {
    Make: 'ISUZU',
    ModelList: ['TROOPER', 'D-MAX', 'RODEO'],
  },
  {
    Make: 'JAGUAR',
    ModelList: [
      'E-PACE',
      'E-TYPE',
      'F-PACE',
      'F-TYPE',
      'I-PACE',
      'SOVEREIGN',
      'S-TYPE',
      'V8 XJ SERIES',
      'XE',
      'XF',
      'XJ',
      'XJ SERIES',
      'XJ12',
      'XJ6',
      'XJR',
      'XJS',
      'XK',
      'XK8',
      'XKR',
      'X-TYPE',
    ],
  },
  {
    Make: 'JEEP',
    ModelList: ['CHEROKEE', 'COMMANDER', 'COMPASS', 'GRAND CHEROKEE', 'PATRIOT', 'RENEGADE', 'WRANGLER'],
  },
  {
    Make: 'KIA',
    ModelList: [
      'CARENS',
      'CEED',
      'CERATO',
      'CLARUS',
      'MAGENTIS',
      'MENTOR',
      'MENTOR II',
      'NIRO',
      'OPTIMA',
      'PICANTO',
      'PRO CEED',
      'RIO',
      'SEDONA',
      'SHUMA',
      'SHUMA II',
      'SORENTO',
      'SOUL',
      'SPORTAGE',
      'STINGER',
      'STONIC',
      'VENGA',
    ],
  },
  {
    Make: 'LAMBORGHINI',
    ModelList: ['AVENTADOR', 'COUNTACH', 'DIABLO', 'GALLARDO', 'HURACAN', 'MURCIELAGO', 'URUS', 'JALPA', 'MIURA'],
  },
  {
    Make: 'LANCIA',
    ModelList: ['DELTA'],
  },
  {
    Make: 'LAND ROVER',
    ModelList: [
      'DEFENDER',
      'DISCOVERY',
      'DISCOVERY SPORT',
      'FREELANDER',
      'RANGE ROVER',
      'RANGE ROVER EVOQUE',
      'RANGE ROVER SPORT',
      'RANGE ROVER VELAR',
    ],
  },
  {
    Make: 'LEXUS',
    ModelList: ['CT', 'GS', 'IS', 'LC', 'LS', 'NX', 'RC', 'RX', 'SC', 'LFA'],
  },
  {
    Make: 'LOTUS',
    ModelList: ['2-ELEVEN', 'ELISE', 'ESPRIT', 'EUROPA', 'EVORA', 'EXIGE', 'ELAN', '3-ELEVEN'],
  },
  {
    Make: 'MASERATI',
    ModelList: [
      '3200',
      '4200',
      'GHIBLI',
      'GRANCABRIO',
      'GRANSPORT',
      'GRANTURISMO',
      'LEVANTE',
      'QUATTROPORTE',
      'SPYDER',
    ],
  },
  {
    Make: 'MAYBACH',
    ModelList: ['57', '62'],
  },
  {
    Make: 'MAZDA',
    ModelList: [
      '121',
      '2',
      '3',
      '323',
      '5',
      '6',
      '626',
      'CX-3',
      'CX-5',
      'CX-7',
      'DEMIO',
      'MPV',
      'MX-3',
      'MX-5',
      'PREMACY',
      'RX-7',
      'RX-8',
      'TRIBUTE',
      'XEDOS 6',
      'XEDOS 9',
    ],
  },
  {
    Make: 'MCLAREN',
    ModelList: ['540', '570', '650S', '675LT', '720S', 'MP4-12C', 'P1', '600LT', 'SENNA'],
  },
  {
    Make: 'MERCEDES-BENZ',
    ModelList: [
      '190',
      '200',
      '300',
      'A CLASS',
      'AMG GT',
      'B CLASS',
      'C CLASS',
      'CL CLASS',
      'CLA',
      'CLC',
      'CLK',
      'CLS',
      'E CLASS',
      'G CLASS',
      'GL CLASS',
      'GLA',
      'GLC',
      'GLE',
      'GLS',
      'M CLASS',
      'MCLAREN SLR',
      'R CLASS',
      'S CLASS',
      'SEL SERIES',
      'SL CLASS',
      'SLC',
      'SLK',
      'SLS',
      'V CLASS',
      'VANEO',
      'VIANO',
      'X CLASS',
    ],
  },
  {
    Make: 'MG',
    ModelList: ['MG3', 'MG6', 'MGF', 'MGTF', 'ZR', 'ZS', 'ZT', 'ZT-T', 'GS', 'MGB'],
  },
  {
    Make: 'MINI',
    ModelList: ['CLUBMAN', 'CONVERTIBLE', 'COUNTRYMAN', 'COUPE', 'HATCHBACK', 'PACEMAN', 'ROADSTER'],
  },
  {
    Make: 'MITSUBISHI',
    ModelList: [
      '3000GT',
      'ASX',
      'CARISMA',
      'CHALLENGER',
      'COLT',
      'ECLIPSE CROSS',
      'GALANT',
      'GRANDIS',
      'GTO',
      'I-CAR',
      'I-MIEV',
      'L200',
      'LANCER',
      'MIRAGE',
      'OUTLANDER',
      'PAJERO',
      'PININ',
      'RALLIART EVOLUTION VI',
      'RALLIART EVOLUTION VII',
      'RALLIART FTO',
      'RALLIART GALANT VR4',
      'SHOGUN',
      'SHOGUN PININ',
      'SHOGUN SPORT',
      'SPACE RUNNER',
      'SPACE STAR',
      'SPACE WAGON',
    ],
  },
  {
    Make: 'MORGAN',
    ModelList: ['4/4', 'PLUS 4', '3 WHEELER'],
  },
  {
    Make: 'NISSAN',
    ModelList: [
      '200SX',
      '350Z',
      '370Z',
      'ALMERA',
      'ALMERA TINO',
      'CUBE',
      'E-NV200',
      'GT-R',
      'JUKE',
      'LEAF',
      'MAXIMA QX',
      'MICRA',
      'MURANO',
      'NAVARA',
      'NOTE',
      'NV200',
      'PATHFINDER',
      'PATROL',
      'PIXO',
      'PRIMERA',
      'PULSAR',
      'QASHQAI',
      'QASHQAI+2',
      'QX',
      'SERENA',
      'SKYLINE GT-R',
      'TERRANO II',
      'TIIDA',
      'X-TRAIL',
    ],
  },
  {
    Make: 'NOBLE',
    ModelList: ['M12', 'M600'],
  },
  {
    Make: 'OPEL',
    ModelList: ['ASTRA', 'INSIGNIA'],
  },
  {
    Make: 'PAGANI',
    ModelList: ['HUAYRA', 'ZONDA'],
  },
  {
    Make: 'PERODUA',
    ModelList: ['KELISA', 'KENARI', 'MYVI'],
  },
  {
    Make: 'PEUGEOT',
    ModelList: [
      '1007',
      '106',
      '107',
      '108',
      '2008',
      '205',
      '206',
      '207',
      '208',
      '3008',
      '306',
      '307',
      '308',
      '4007',
      '405',
      '406',
      '407',
      '5008',
      '508',
      '607',
      '806',
      '807',
      'BIPPER TEPEE',
      'EXPERT TEPEE',
      'ION',
      'PARTNER COMBI',
      'PARTNER ORIGIN COMBI',
      'PARTNER TEPEE',
      'RCZ',
      'TRAVELLER',
      'RIFTER',
    ],
  },
  {
    Make: 'PORSCHE',
    ModelList: [
      '356',
      '718',
      '911',
      '912',
      '918',
      '924',
      '928',
      '944',
      '968',
      'BOXSTER',
      'CARRERA GT',
      'CAYENNE',
      'CAYMAN',
      'MACAN',
      'PANAMERA',
    ],
  },
  {
    Make: 'PROTON',
    ModelList: ['EXORA', 'GEN-2', 'IMPIAN', 'PERSONA', 'PREVE', 'SATRIA', 'SATRIA NEO', 'SAVVY', 'WIRA'],
  },
  {
    Make: 'RENAULT',
    ModelList: [
      'AVANTIME',
      'CAPTUR',
      'CLIO',
      'ESPACE',
      'GRAND ESPACE',
      'GRAND MODUS',
      'GRAND SCENIC',
      'KADJAR',
      'KANGOO',
      'KOLEOS',
      'LAGUNA',
      'MEGANE',
      'MEGANE SCENIC',
      'MODUS',
      'SCENIC',
      'SCENIC XMOD',
      'TRAFFIC',
      'TWINGO',
      'TWIZY',
      'VEL SATIS',
      'WIND',
      'ZOE',
    ],
  },
  {
    Make: 'ROLLS-ROYCE',
    ModelList: [
      'CULLINAN',
      'CORNICHE',
      'DAWN',
      'GHOST',
      'PARK WARD',
      'PHANTOM',
      'SILVER DAWN',
      'SILVER SERAPH',
      'SILVER SHADOW',
      'SILVER SPIRIT',
      'SILVER SPUR',
      'WRAITH',
    ],
  },
  {
    Make: 'ROVER',
    ModelList: ['100', '200', '25', '400', '45', '600', '75', 'CITYROVER', 'MINI', 'STREETWISE', 'TOURER'],
  },
  {
    Make: 'SAAB',
    ModelList: ['900', '9000', '9-3', '9-3X', '9-5'],
  },
  {
    Make: 'SEAT',
    ModelList: [
      'ALHAMBRA',
      'ALTEA',
      'ARONA',
      'AROSA',
      'ATECA',
      'CORDOBA',
      'EXEO',
      'IBIZA',
      'LEON',
      'LEON X-PERIENCE',
      'MII',
      'TOLEDO',
      'TARRACO',
    ],
  },
  {
    Make: 'SKODA',
    ModelList: ['CITIGO', 'FABIA', 'FELICIA', 'KAROQ', 'KODIAQ', 'OCTAVIA', 'RAPID', 'ROOMSTER', 'SUPERB', 'YETI'],
  },
  {
    Make: 'SMART',
    ModelList: ['CITY', 'FORFOUR', 'FORTWO', 'ROADSTER'],
  },
  {
    Make: 'SPYKER',
    ModelList: ['C8'],
  },
  {
    Make: 'SSANGYONG',
    ModelList: [
      'KORANDO',
      'KYRON',
      'MUSSO',
      'REXTON',
      'REXTON W',
      'RODIUS',
      'SPORTS',
      'TIVOLI',
      'TIVOLI XVL',
      'TURISMO',
    ],
  },
  {
    Make: 'SUBARU',
    ModelList: ['BRZ', 'FORESTER', 'IMPREZA', 'JUSTY', 'LEGACY', 'LEVORG', 'OUTBACK', 'TRIBECA', 'WRX STI', 'XV'],
  },
  {
    Make: 'SUZUKI',
    ModelList: [
      'ALTO',
      'BALENO',
      'CAPPUCCINO',
      'CELERIO',
      'GRAND VITARA',
      'IGNIS',
      'JIMNY',
      'KIZASHI',
      'LIANA',
      'SPLASH',
      'SWIFT',
      'SX4',
      'SX4 S CROSS',
      'VITARA',
      'WAGON R',
      'X-90',
    ],
  },
  {
    Make: 'TESLA',
    ModelList: ['MODEL S', 'MODEL X'],
  },
  {
    Make: 'TOYOTA',
    ModelList: [
      '4RUNNER',
      'AURIS',
      'AVENSIS',
      'AYGO',
      'CAMRY',
      'CARINA E',
      'CELICA',
      'C-HR',
      'COROLLA',
      'GT86',
      'HILUX',
      'IQ',
      'LAND CRUISER',
      'MR2',
      'PASEO',
      'PICNIC',
      'PREVIA',
      'PRIUS',
      'PRIUS+',
      'RAV 4',
      'STARLET',
      'SUPRA',
      'URBANCRUISER',
      'VERSO',
      'YARIS',
    ],
  },
  {
    Make: 'TRIUMPH',
    ModelList: ['STAG', 'TR3A', 'TR4A', 'HERALD', 'TR6'],
  },
  {
    Make: 'TVR',
    ModelList: [
      'CERBERA',
      'CHIMAERA',
      'GRIFFITH',
      'SAGARIS',
      'T350 C',
      'T350 T',
      'T400 R',
      'T440 R',
      'TAMORA',
      'TUSCAN',
      'TYPHON',
    ],
  },
  {
    Make: 'VAUXHALL',
    ModelList: [
      'ADAM',
      'AGILA',
      'AMPERA',
      'ANTARA',
      'ASTRA',
      'CALIBRA',
      'CASCADA',
      'COMBO TOUR',
      'CORSA',
      'CROSSLAND X',
      'FRONTERA',
      'GRANDLAND X',
      'INSIGNIA',
      'MERIVA',
      'MOKKA',
      'MOKKA X',
      'MONARO',
      'MONTEREY',
      'OMEGA',
      'SIGNUM',
      'SINTRA',
      'TIGRA',
      'VECTRA',
      'VIVA',
      'VIVARO',
      'VX220',
      'VXR8',
      'ZAFIRA',
    ],
  },
  {
    Make: 'VOLKSWAGEN',
    ModelList: [
      'AMAROK',
      'ARTEON',
      'BEETLE',
      'BORA',
      'CADDY CAMPER',
      'CADDY LIFE',
      'CADDY MAXI LIFE',
      'CALIFORNIA',
      'CARAVELLE',
      'CC',
      'CORRADO',
      'EOS',
      'FOX',
      'GOLF',
      'JETTA',
      'LUPO',
      'PASSAT',
      'PHAETON',
      'POLO',
      'SCIROCCO',
      'SHARAN',
      'TIGUAN',
      'TOUAREG',
      'TOURAN',
      'T-ROC',
      'UP',
      'T-CROSS',
      'TRANSPORTER',
    ],
  },
  {
    Make: 'VOLVO',
    ModelList: [
      '440',
      '460',
      '480',
      '850',
      '940',
      '960',
      'C30',
      'C70',
      'CROSS COUNTRY',
      'S40',
      'S60',
      'S60 R',
      'S70',
      'S80',
      'S90',
      'V40',
      'V50',
      'V60',
      'V70',
      'V90',
      'XC40',
      'XC60',
      'XC70',
      'XC90',
    ],
  },
  {
    Make: 'WESTFIELD',
    ModelList: ['ROADSTER', 'SEI', 'SPORT'],
  },
  {
    Make: 'BAC',
    ModelList: ['MONO'],
  },
  {
    Make: 'Cupra',
    ModelList: ['ATECA'],
  },
  {
    Make: 'KTM',
    ModelList: ['X-BOW'],
  },
  {
    Make: 'ZENOS',
    ModelList: ['E10'],
  },
]

export default makesModels
